<footer class="footer">
  <div class="container">
    <p class="footer__copy">&copy; {{ currentYear }} {{ business.name }} | Todos los derechos reservados.</p>

    <div class="footer__status">
      <span class="footer__version">
        v{{ appVersion }}
        @if (envLabel) {
          <span class="footer__env-badge" [class]="'footer__env-badge--' + envName">{{ envLabel }}</span>
        }
      </span>

      <span
        class="footer__network"
        [class.footer__network--online]="isOnline()"
        [class.footer__network--offline]="!isOnline()"
        [attr.title]="isOnline() ? 'Conectado a la red' : 'Sin conexión a la red'"
      >
        <span class="footer__network-dot" aria-hidden="true"></span>
        {{ isOnline() ? 'En línea' : 'Sin conexión' }}
      </span>
    </div>
  </div>
</footer>
